import TabOptionsHeader from './TabOptionsHeader';

export default TabOptionsHeader;
